<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
interface Slide {
  id: number;
  class?: string;
  url: string;
  thumbUrl: string;
  thumbWidth: number;
  thumbHeight: number;
  width: number;
  height: number;
  alt: string;
}

const props = defineProps({
  slideshow: Array as () => Slide[],
  id: String,
});

const windowWidth = ref(0);
const isMobile = ref(false);

const itemsToShow = ref(3.5);
const itemsToScroll = ref(1);

function updateWidth() {
  isMobile.value = window.innerWidth <= 991;
  windowWidth.value = window.innerWidth;

  if (isMobile.value) {
    itemsToShow.value = 1.5;
    itemsToScroll.value = 1;
  } else {
    itemsToShow.value = 3.5;
    itemsToScroll.value = 1;
  }
}

onMounted(() => {
  isMobile.value = window.innerWidth <= 991;
  updateWidth();
  if (isMobile.value) {
    itemsToShow.value = 1.5;
    itemsToScroll.value = 1;
  } else {
    itemsToShow.value = 3.5;
    itemsToScroll.value = 1;
  }
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});
</script>

<template>
  <Carousel
    :id="props.id"
    :items-to-show="itemsToShow"
    :items-to-scroll="itemsToScroll"
    :wrap-around="true"
  >
    <Slide v-for="slide in props.slideshow?.slice(0, 20)" :key="slide.id">
      <div class="carousel__item">
        <NuxtPicture
          format="webp"
          loading="lazy"
          fit="inside"
          :src="slide.thumbUrl"
          :width="600"
          :height="400"
          :alt="slide.alt"
          sizes="sm:90vw md:400px lg:600px"
        />
      </div>
    </Slide>
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>
